/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useUpdateGcpAccountCredentialsBatchMutation } from "~/generated/graphql";
import { Provider } from "../../types";
import { UpdateHandlerVariables } from "../types";

export function useBatchUpdateGcpAccountCredentials() {
  const [updateGcpCredentials, ...mutationState] =
    useUpdateGcpAccountCredentialsBatchMutation();

  const handleGcpCredentialsUpdate = async (
    variables: UpdateHandlerVariables<Provider.Gcp>,
    selectedNids: string[]
  ) => {
    const { key } = variables;

    await updateGcpCredentials({
      variables: {
        nids: selectedNids,
        input: JSON.parse(key),
      },
    });
  };

  return [handleGcpCredentialsUpdate, mutationState] as const;
}
